import {extractIndoorMapLink} from "../util/util";
import GoogleMapLoader from "./map/GoogleMapLoader";
import CallHistory from "./CallHistory";
import React, {useCallback, useEffect, useMemo, useState} from "react";

const Maps = ({topEmlLocation, callUuid, history}) => {
    const [updateLocations, setUpdateLocations] = useState(true);
    const [markerToDisplay, setMarkerToDisplay] = useState(null);

    let hrl = topEmlLocation.rankedLocations && topEmlLocation?.rankedLocations.length
        ? topEmlLocation?.rankedLocations[0].humanReadableLocation
        : "";
    hrl = hrl.replace(/(\n)+/g, "\n");
    let {parsedData} = extractIndoorMapLink(hrl);

    // Create a text representation for location checking
    const locationText = [
        parsedData.room,
        parsedData.floor,
        ...parsedData.otherLines
    ].filter(Boolean).join(" ").toLowerCase();

    const isEliOfficeLocation = locationText.indexOf("bedford") !== -1
        && locationText.indexOf("380") !== -1;
    const isTestLocation = locationText.indexOf("9200 corporate") !== -1;
    const isMYLocation = locationText.indexOf("manu tests") !== -1;
    const [activeTab, setActiveTab] = useState("LocationTab");

    const historyClickHandler = useCallback((historyItemIndex) =>
            // history starts from most recent but one
            setMarkerToDisplay(getMarkerToDisplay(history[historyItemIndex + 1].payload[0])),
        [history]);

    useEffect(() => {
        if (updateLocations) {
            setMarkerToDisplay(getMarkerToDisplay(topEmlLocation));
        }
    }, [updateLocations, topEmlLocation]);

    const topHistoryItem = useMemo(() => [history[0]], [history]);

    return <div className="flex flex-col">
        <div className="w-screen h-screen max-w-full max-h-full z-5 flex flex-col">
            <GoogleMapLoader
                isEliOfficeLocation={isEliOfficeLocation}
                isTestLocation={isTestLocation}
                isMYLocation={isMYLocation}
                locationMarker={markerToDisplay}
                updateLocations={updateLocations}
                setUpdateLocations={setUpdateLocations}
            />
        </div>
        <div className="w-screenmax-w-md">
            <div className="flex border-b border-gray-300">
                <button
                    onClick={() => setActiveTab("LocationTab")}
                    className={`flex-1 py-2 px-4 text-center ${
                        activeTab === "LocationTab"
                            ? "border-b-2 border-blue-500 font-semibold text-blue-600"
                            : "text-gray-500"
                    }`}
                >
                    Location
                </button>
                <button
                    onClick={() => setActiveTab("HistoryTab")}
                    className={`flex-1 py-2 px-4 text-center ${
                        activeTab === "HistoryTab"
                            ? "border-b-2 border-blue-500 font-semibold text-blue-600"
                            : "text-gray-500"
                    }`}
                >
                    History
                </button>
            </div>
            <div className="p-4 border border-t-0 rounded-b shadow">
                {activeTab === "LocationTab" && <div>
                    <div className="flex flex-row overflow-y-auto max-h-50 bg-slate-200">
                        <CallHistory callUuid={callUuid}
                                     history={topHistoryItem}
                                     clickAllowed={false}/>
                    </div>
                </div>}
                {activeTab === "HistoryTab" && <div>
                    <CallHistory clickHandler={historyClickHandler}
                                 clickAllowed={!updateLocations}
                                 callUuid={callUuid}
                                 history={history.slice(1)}/>
                </div>}
                <div className="w-full flex flex-row">
                    <span
                        className="ml-auto m-2 p-2 max-w-fit font-medium text-sm text-slate-700 bg-blue-200 rounded-md">{history?.length} updates</span>
                </div>
            </div>
        </div>
    </div>
};

export default Maps;

const getMarkerToDisplay = (topEmlLocation) => {
    const {rankedLocations} = topEmlLocation;
    // console.log("marker to display", rankedLocations.length ? rankedLocations[0].deviceId : "no location");
    if (!rankedLocations || !rankedLocations.length) return {
        lat: topEmlLocation.gpsLatitude,
        lng: topEmlLocation.gpsLongitude,
        type: "gps",
        id: "1"
    };

    if (topEmlLocation.gpsEstimated) return {
        lat: topEmlLocation.gpsLatitude,
        lng: topEmlLocation.gpsLongitude,
        type: "aps",
        id: "1",
        floor: rankedLocations[0].dispatchableAddress.floor
    };

    return {
        lat: rankedLocations[0].tagGpsLatitude,
        lng: rankedLocations[0].tagGpsLongitude,
        type: "aps",
        id: "1",
        floor: rankedLocations[0].dispatchableAddress.floor,
    };
};
